import { render } from "./Awarded.vue?vue&type=template&id=59e15c21&scoped=true"
import script from "./Awarded.vue?vue&type=script&lang=js"
export * from "./Awarded.vue?vue&type=script&lang=js"

import "./Awarded.vue?vue&type=style&index=0&id=59e15c21&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-59e15c21"

export default script